// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/** Supported agent pattern prefixes — determines the frontend parser */
export type AgentPattern =
  | `agui-${string}`
  | `strands-${string}`
  | `langgraph-${string}`
  | `claude-${string}`

/** Canonical assistant IDs used for runtime selection and stored data labels. */
export type AgentName =
  | "survey-variable-discovery"
  | "deep-literature-review"
  | "exploratory-literature-review"

export const DEFAULT_AGENT_NAME: AgentName = "survey-variable-discovery"

/** Configuration for AgentCoreClient */
export interface AgentCoreConfig {
  runtimeArn: string
  region?: string
  pattern: AgentPattern
  localAgentUrl?: string
}

/** Stream event types emitted by parsers */
export type StreamEvent =
  | { type: "text"; content: string }
  | { type: "tool_use_start"; toolUseId: string; name: string }
  | { type: "tool_use_delta"; toolUseId: string; input: string }
  | { type: "tool_result"; toolUseId: string; result: string }
  | { type: "message"; role: string; content: unknown[] }
  | { type: "result"; stopReason: string }
  | { type: "usage"; inputTokens: number; outputTokens: number; totalTokens: number; latencyMs?: number }
  | { type: "lifecycle"; event: string }

/** Callback invoked with each stream event */
export type StreamCallback = (event: StreamEvent) => void

/** Parses a single SSE line and emits events via callback */
export type ChunkParser = (line: string, callback: StreamCallback) => void
